export enum CurrencyExchangeProviderType {
    Manual = 'manual',
    Wise = 'wise',
    Airwallex = 'airwallex',
}
